// useGiftCodes.ts
/*
//ギフトコードを扱うサービス
*/

import { useState, useEffect } from 'react';
import { collection, onSnapshot, query } from 'firebase/firestore';
import { db, appId } from '../firebase';
import { GiftCode } from '../types';
import { logger } from '../utils/logger';

// Firestoreのコレクションパスを定義
const GIFT_CODE_COLLECTION_PATH = `artifacts/${appId}/public/data/giftcode`;

/**
 * Firestoreからすべてのギフトコードをリアルタイムで取得するカスタムフック
 *
 * @returns
 * - giftCodes: ギフトコードの配列
 * - loading: データ読み込み中を示すブール値
 * - error: エラーが発生した場合のエラーオブジェクト
 */
export const useGiftCodes = () => {
    const [giftCodes, setGiftCodes] = useState<GiftCode[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        const giftCodesCollectionRef = collection(db, GIFT_CODE_COLLECTION_PATH);
        const q = query(giftCodesCollectionRef);

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            try {
                const data: GiftCode[] = querySnapshot.docs.map(doc => ({
                    giftCode: doc.id,
                    ...doc.data()
                })) as GiftCode[];
                setGiftCodes(data);
                setLoading(false);
            } catch (err: any) {
                logger.error('Failed to fetch gift codes with onSnapshot:', err);
                setError(new Error('ギフトコードの読み込みに失敗しました。'));
                setLoading(false);
            }
        }, (err) => {
            logger.error('onSnapshot error:', err);
            setError(new Error('リアルタイムデータの取得中にエラーが発生しました。'));
            setLoading(false);
        });

        // コンポーネントがアンマウントされたときにリスナーを解除
        return () => unsubscribe();
    }, []);

    return { giftCodes, loading, error };
};
